// extracted by mini-css-extract-plugin
export default {"image":"ImageItem_image__kojxg"};